import { render, staticRenderFns } from "./PopupAddFloorplan.vue?vue&type=template&id=2ec27495&scoped=true&"
import script from "./PopupAddFloorplan.vue?vue&type=script&lang=js&"
export * from "./PopupAddFloorplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec27495",
  null
  
)

export default component.exports